import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Ingredients from "./components/Ingredients";
import Benefits from "./components/Benefits";
import HowToUse from "./components/HowToUse";
import WhyUs from "./components/WhyUs";
import Testimonials from "./components/Testimonials";
import Reviews from "./components/Reviews";
import OrderForm from "./components/OrderForm";
import ProductGallery from "./components/ProductGallery";
import { detoxReviews } from "./data/content";
import CartDrawer from "./components/CartDrawer";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import Toast from "./components/Toast";
import WeightLossPage from "./components/WeightLossPage";
import DetoxPage from "./components/DetoxPage";

export default function App() {
  const [route, setRoute] = useState(window.location.hash || "#home");
  const [toastVisible, setToastVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);
  const [totalSales, setTotalSales] = useState(0);

  useEffect(() => {
    const updateRoute = () => setRoute(window.location.hash || "#home");
    window.addEventListener("hashchange", updateRoute);
    return () => window.removeEventListener("hashchange", updateRoute);
  }, []);

  useEffect(() => {
    if (route === "#weight-loss" || route === "#detox") {
      window.scrollTo(0, 0);
    }
  }, [route]);

  useEffect(() => {
    const saved = window.localStorage.getItem("swathi-sales-count");
    if (saved) {
      const parsed = Number(saved);
      if (!Number.isNaN(parsed)) setTotalSales(parsed);
    }
  }, []);

  useEffect(() => {
    window.localStorage.setItem("swathi-sales-count", String(totalSales));
  }, [totalSales]);

  function showToast() {
    setToastVisible(true);
    setTimeout(() => setToastVisible(false), 3000);
  }

  function addToCart(product, quantity) {
    setCartItems((prev) => {
      const existing = prev.find((item) => item.product.id === product.id);
      if (existing) {
        return prev.map((item) =>
          item.product.id === product.id
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      }
      return [...prev, { product, quantity }];
    });
    setCartOpen(true);
  }

  function updateCartQuantity(productId, quantity) {
    setCartItems((prev) =>
      prev
        .map((item) =>
          item.product.id === productId
            ? { ...item, quantity: Math.max(1, quantity) }
            : item
        )
        .filter((item) => item.quantity > 0)
    );
  }

  function removeCartItem(productId) {
    setCartItems((prev) => prev.filter((item) => item.product.id !== productId));
  }

  function openCart() {
    setCartOpen(true);
  }

  function closeCart() {
    setCartOpen(false);
  }

  function continueToOrder() {
    setCartOpen(false);
    document.getElementById("order")?.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function trackSale(orderData = {}) {
    const quantity =
      orderData.items?.reduce((sum, item) => sum + (item.quantity || 1), 0) ||
      Number(orderData.quantity || 1);

    if (quantity > 0) {
      setTotalSales((prev) => prev + quantity);
    }
  }

  return (
    <>
      <Navbar
        searchQuery={searchQuery}
        onSearchQueryChange={setSearchQuery}
      />
      {route === "#weight-loss" ? (
        <WeightLossPage onHome={() => (window.location.hash = "#home")} onAddToCart={addToCart} />
      ) : route === "#detox" ? (
        <DetoxPage
          onHome={() => (window.location.hash = "#home")}
          onAddToCart={addToCart}
        />
      ) : (
        <>
          <main>
            <Hero />
            <Marquee />
            <ProductGallery
              searchQuery={searchQuery}
              onProductSelect={setSelectedProduct}
              onAddToCart={addToCart}
            />
            <Ingredients />
            <Benefits />
            <HowToUse />
            <WhyUs />
            <Reviews
              eyebrow="DETOX REVIEWS"
              title="What Detox Customers Are Saying"
              reviews={detoxReviews}
              sectionId="detox-reviews"
              orderTarget="#order"
            />
            <Testimonials />
            <OrderForm
              onOrderPlaced={(orderData) => {
                showToast();
                trackSale(orderData);
              }}
              selectedProduct={selectedProduct}
              totalSales={totalSales}
            />
          </main>
          <Footer />
        </>
      )}
      <WhatsAppFloat
        cartCount={cartItems.reduce((sum, item) => sum + item.quantity, 0)}
        onOpenCart={openCart}
      />
      <CartDrawer
        open={cartOpen}
        cartItems={cartItems}
        onClose={closeCart}
        onUpdateQuantity={updateCartQuantity}
        onRemoveItem={removeCartItem}
        onContinueToOrder={continueToOrder}
        onCheckout={(orderData) => trackSale(orderData)}
      />
      <Toast
        visible={toastVisible}
        message="✅ Redirecting to WhatsApp to confirm your order!"
      />
    </>
  );
}
